import React from 'react';
import { Specifications } from '../../../../_metronic/layout/components/basePage/insidePages/Specifications';
import { SpecificationsUIProvider } from '../../../../_metronic/layout/components/basePage/insidePages/SpecificationsUIContext';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import { SelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField';
import { sortCaret } from '../../../../_metronic/_helpers';
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/insidePages/column-formatters";


const init = {
    id: undefined,
    roleId: 0,
    roleTitle: "",
    placeTitle: "",
    allowed: true,
    isDeleted: false,
};

const columns = [
    {
        dataField: "placeTitle",
        text: columnFormatters.translateByMessageId("MODULES.BASEINFO.PLACE.TITLE"),
        sort: true,
        sortCaret: sortCaret,
    },

    {
        dataField: "allowed",
        text: columnFormatters.translateByMessageId("MODULES.GENERAL.ALLOWED"),
        sort: true,
        sortCaret: sortCaret,
        formatter: columnFormatters.AllowedColumnFormatter,
    },

    // {
    //   dataField: "action",
    //   text: "Actions",
    //   formatter: ActionsColumnFormatter,
    //   formatExtraData: {
    //     openEditSpecificationDialog: specsUIProps.openEditSpecificationDialog,
    //     openDeleteSpecificationDialog:
    //       specsUIProps.openDeleteSpecificationDialog,
    //   },
    //   classes: "text-right pr-0",
    //   headerClasses: "text-right pr-3",
    //   style: {
    //     minWidth: "100px",
    //   },
    // },
];


export const prepareFilter = (queryParams, values) => {
    const { allowed, roleId } = values;
    const newQueryParams = { ...queryParams };
    const filter = {};

    filter.allowed = allowed !== "" ? +allowed : undefined;
    filter.roleId = roleId !== "" ? +roleId : 0;
    // filter.menuId = menuId !== "" ? +menuId : 0;


    // // Filter by all fields
    // filter.title = searchText;
    // if (searchText) {
    //     filter.title = searchText;
    // }
    newQueryParams.filter = filter;

    // let whereClause = "title.contains(@0)"
    let whereClause = ""
    const whereClauseParameters = [];
    // whereClauseParameters.push(searchText)

    // whereClause = whereClause + "isDeleted=@0"
    // whereClauseParameters.push(false)

    if (filter.roleId > 0) {
        whereClause = whereClause + "roleId=@0"
        whereClauseParameters.push(filter.roleId)
    }
    else {
        whereClause = whereClause + "roleId!=@0"
        whereClauseParameters.push(0)
    }

    // if (filter.menuId > 0) {
    //     whereClause = whereClause + " and menuId=@1"
    //     whereClauseParameters.push(filter.menuId)
    // }
    // else {
    //     whereClause = whereClause + " and menuId!=@1"
    //     whereClauseParameters.push(0)
    // }

    newQueryParams.whereClause = whereClause;
    newQueryParams.whereClauseParameters = whereClauseParameters;


    return newQueryParams;
};


export const filterInitialValues = {
    filter: {
        searchText: "",
        roleId: 0
    },
    sortOrder: "asc", // asc||desc
    sortField: "id",
    pageNumber: 1,
    pageSize: 10,

    whereClause: "",
    whereClauseParameters: [
    ],
    orderClause: "id desc ",
    skipCount: 0,
    takeCount: 10,
};
export const filterFields = [
    // {
    //     name: "menuId",
    //     lable: "MODULES.BASEINFO.MENU.TITLE",
    //     type: "component",
    //     list: [],
    //     component: (props) =>
    //         <SelectObjectsField api="api/menu"
    //             reduxState="menus"
    //             sname="menuId"
    //             {...props} />
    // },
];

export const PlaceAccessPage = ({ id }) => {
    return (

        // <BaseAccessPage 
        // currentParentId={id} 
        // initSpecification={init} 
        // api="api/MenuAccess" 
        // reduxName="menuPermissions" 
        // columns={columns} 
        // prepareFilter={prepareFilter}
        // filterInitialValues={filterInitialValues} 
        // filterFields={filterFields} 
        // haveFullAccess={true} />
        <FilterObjectsUIProvider initialFilter={filterInitialValues}>
            <SpecificationsUIProvider currentParentId={id} currentParentName="roleId" initSpecification={init}>
                <Specifications currentParentId={id} api="api/PlaceAccess" reduxName="placePermissions" columns={columns} prepareFilter={prepareFilter}
                    filterInitialValues={filterInitialValues} filterFields={filterFields} haveFullAccess={false} />
            </SpecificationsUIProvider>
        </FilterObjectsUIProvider>
    )
}




